import * as React from "react";
import { LinearProgress } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(8, 'auto'),
    textAlign: 'center',
    width: '60%',
    '& p': {
      margin: theme.spacing(2),
      fontWeight: 600,
      fontSize: '1.1rem',
    },
  },
}));

interface Props {
  label?:string;
}

export const Loader:React.FC<Props> = (props:Props) => {
  const { label } = props;
  const classes = useStyles();
  return(
    <div className={classes.root}>
      <LinearProgress color="primary" />
      {label &&
        <p>{label}</p>
      }
    </div>
  );
}